import { SET_LOADING } from 'store/loading/types';
import { ILoadingAction, ILoadingState, ELoadingType } from './types';

const initialState: ILoadingState = {
  loading: ELoadingType.OPENING_IMAGE,
};

export default function(state = initialState, action: ILoadingAction) {
  switch (action.type) {
    case SET_LOADING: {
      return {
        loading: action.loading,
      };
    }

    default: {
      return state;
    }
  }
}
